module.exports = __webpack_public_path__ + "img/selected7-min.d29bd211.png";